export const url = {
  commentList: '/auth/comment/findBackList',
  commentDetail: '/auth/comment/findBack',
  commentModule: '/auth/dictionaries/findByParentId',
  submit: '/auth/feedback/save',
  list: '/manage/feedback/findList',
  export: '/auth/backFeedback/export',
  module: '/auth/feedbackPosition/findFilterByParentId',
  role: '/auth/userRole/findFilter',
  changeCommentDisplay: '/auth/comment/changeCommentDisplay',
  getCommentApproveStatus: '/auth/comment/getCommentApproveStatus',
  changeCommentApprove: '/auth/comment/changeCommentApprove',
  findFilterRoles: '/auth/userRole/findFilterRoles'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/feedback.js